<template>
	<div>

		<div class="uk-container-expand contactsScreen">
				<appNav></appNav>
		</div>


		<div class="uk-container contactsScreen">
		
			<div class="uk-h3">{{ ms }}</div>
			<hr class="uk-divider-icon">

			<div uk-grid>

					<div class="uk-width-expand">

						<article class="uk-article">
								<div class="uk-h3 uk-flex uk-flex-middle uk-margin-remove titleCont"> <i class="mdi mdi-sign-direction"></i> Хлебная мануфактура «ГРIДНЕВЪ»</div>
								<div class="contactsLeft">
									<p class="uk-article-meta uk-margin-remove">Ростов-на-Дону</p>
									<p class="uk-margin-remove">344064</p>
									<p class="uk-margin-remove">ул. Вавилова, 62/1</p>
									<ul class="uk-list">
									<li>	<i class="mdi mdi-phone-in-talk"></i>
									<a href="tel:88632732320">+7 (863) 273-23-20</a>
									</li>
									<li>
									<i class="mdi mdi-at"></i>
									<a href="mailto:DONPEKAR@MAIL.RU">donpekar@mail.ru
									</a>
									</li>
									</ul>
								
									<div>
										
									</div>
								</div>
						</article>

						<article class="uk-article">
								<div class="uk-h3 uk-flex uk-flex-middle uk-margin-remove titleCont"><i class="mdi mdi-account-supervisor"></i> По вопросам сотрудничества</div>
								<div class="contactsLeft">
									<p class="uk-article-meta uk-margin-remove">Ростов-на-Дону</p>
									<ul class="uk-list uk-margin-remove">
										<li class="timeOrder">Отдел продаж:</li>

										<li><i class="mdi mdi-phone-in-talk"></i> <a href="tel:88632732320">+7 (863) 273-23-20</a></li>
										<li><i class="mdi mdi-phone-in-talk"></i> <a href="tel:89614243883">+7 (961) 424-38-83</a></li>
										<li class="timeOrder">Отдел снабжения:</li>
										<li><i class="mdi mdi-phone-in-talk"></i> <a href="tel:88632775391">+7 (863) 277-53-91</a></li>
										<li class="timeOrder">Отдел технологов:</li>
										<li><i class="mdi mdi-phone-in-talk"></i> <a href="tel:88632775391">+7 (863) 277-53-91</a></li>

									</ul>
				
								</div>
						</article>


						<article class="uk-article">
								<div class="uk-h3 uk-flex uk-flex-middle uk-margin-remove titleCont"><i class="mdi mdi-alert-octagram"></i>По вопросам качества продукции</div>
								<div class="contactsLeft">
									<ul class="uk-list">
										<li><i class="mdi mdi-phone-in-talk"></i> <a href="tel:89612904744">+7 (961) 290-47-44</a></li>
									</ul>
								</div>
						</article>

						<article class="uk-article">
								<div class="uk-h3 uk-flex uk-flex-middle uk-margin-remove titleCont"><i class="mdi mdi-axis-arrow"></i>Фирменная розничная сеть «ГРIДНЕВЪ-ХЛЕБЪ»</div>
								<div class="contactsLeft">
									<p class="uk-article-meta uk-margin-remove">Ростов-на-Дону</p>
									<i class="mdi mdi-at"></i>
									<a href="mailto:gridnevhleb@mail.ru">gridnevhleb@mail.ru</a>
								</div>
						</article>

					</div>

					<div class="uk-width-1-2 uk-cover-container uk-visible@s">
						<img src="/img/gridnev2.jpg" alt="" uk-cover>
					</div>

			</div>

		
		</div>
<br>
<br>
<br>

		<div class="uk-container-expand">
			<div class="uk-width-1-1">
<iframe src="https://www.google.com/maps/d/u/0/embed?mid=1AXsnLFzhOnDuFxLKqigq-14beFdJv9zL" width="100%" height="480"></iframe>

			</div>
		</div>
		</div>
</template>


<script>
import appNav from '@/components/Nav'

export default {
	data () {
		return {
			ms: 'Контакты'
		}
	},
	components: {
		appNav
	}
}
</script>


<style>
.contactsScreen .uk-navbar-container:not(.uk-navbar-transparent) {
	background: linear-gradient(0deg, rgba(0, 0, 0, 0.0001) 0%, #ecf0f1 150.79%);
}

.contactsScreen .uk-navbar-nav>li>a {
	font-weight: 500;
}

.contactsScreen .uk-article {
margin-top: 0px !important;
margin-bottom: 15px;
}

.titleCont {
	margin-bottom: 5px !important;
}

.iconTitle{
	margin-right: 15px;
}

.contactsLeft {
	margin-left: 36px;
}

.uk-accordion-title{
display: inline-block !important;
}

.uk-article i{
	margin-right: 10px;
	color:#95a5a6;
}

.timeOrder {
	font-weight: 500;
}
</style>